export const RESET_START = 'forgot-password/reset-start';
export const RESET_SUCCESS = 'forgot-password/reset-success';
export const RESET_ERROR = 'forgot-password/reset-error';
